export default {
	project_name: 'CRM Play',
	see_the_full_ranking: 'Ver más',
	company_agency: 'Tienda',
}
